<div style="margin-top: -3.3em; float: left">
  <p-select [options]="pagingSizeItems" [(ngModel)]="pageSize" appendTo="body"></p-select>
</div>
